/**
 * Modal para mostrar errores de verificación de stock SAP
 *
 * Muestra los errores detallados devueltos por el endpoint
 * deliverWarehouseItemStockCheck, permitiendo al usuario
 * identificar qué items tienen problemas de stock.
 */

import React from 'react';
import {
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	Button,
	Alert,
} from 'reactstrap';

export const StockCheckErrorModal = ({
	isOpen,
	onClose,
	errorMessage,
	errorDetails,
}) => {
	return (
		<Modal isOpen={isOpen} toggle={onClose} centered size='lg'>
			<ModalHeader toggle={onClose} className='bg-danger text-white'>
				<i className='ri-error-warning-line me-2'></i>
				Error de Verificación de Stock
			</ModalHeader>
			<ModalBody>
				<Alert color='danger' className='mb-3'>
					<i className='ri-close-circle-line me-2'></i>
					<strong>
						{errorMessage?.response?.data?.detail?.message ||
							'Se encontraron errores al verificar el stock en SAP'}
					</strong>
				</Alert>

				{errorDetails?.length > 0 && (
					<div className='mb-3'>
						<h6 className='text-muted mb-2'>Detalle de errores:</h6>
						<ul className='list-group'>
							{errorDetails.map((error, idx) => {
								// error puede ser un array [mensaje, datos] o un string
								const message = Array.isArray(error) ? error[0] : error;
								const data =
									Array.isArray(error) && error[1] ? error[1] : null;

								return (
									<li
										key={idx}
										className='list-group-item list-group-item-danger'
									>
										<i className='ri-close-line me-2'></i>
										{message}
										{data && (
											<small className='d-block text-muted mt-1'>
												{typeof data === 'object'
													? JSON.stringify(data, null, 2)
													: data}
											</small>
										)}
									</li>
								);
							})}
						</ul>
					</div>
				)}

				<Alert color='info' className='mb-0'>
					<i className='ri-information-line me-2'></i>
					<strong>¿Qué puede hacer?</strong>
					<ul className='mb-0 mt-2'>
						<li>Quitar los items con problemas de la lista</li>
						<li>Verificar el stock disponible en SAP</li>
						<li>Contactar al administrador si el problema persiste</li>
					</ul>
				</Alert>
			</ModalBody>
			<ModalFooter>
				<Button color='primary' onClick={onClose}>
					<i className='ri-check-line me-1'></i>
					Entendido, corregir datos
				</Button>
			</ModalFooter>
		</Modal>
	);
};
